// @ts-nocheck
import React from 'react';
import PropTypes from 'prop-types';

import InfoIconButton from '../OtherDetails/InfoIconButton';
import MultiEditAttributeField from '../MultiEditAttributeField';

// MultiEditAttributeField centers `endAdornmentExtra` against just its input
// row, so the InfoIconButton stays vertically centered on the input regardless
// of whether a label or draft footer is also rendered above/below it.
const AttributeEditWithInfo = ({
  attribute,
  showAttributeInfo,
  attributeSourceMapping,
  isSourceMappingLoading,
  isNewVariant,
  fieldProps,
}) => (
  <MultiEditAttributeField
    attribute={attribute}
    isNewVariant={isNewVariant}
    endAdornmentExtra={
      showAttributeInfo ? (
        <InfoIconButton
          attribute={attribute}
          attributeSourceMapping={attributeSourceMapping}
          loading={isSourceMappingLoading}
        />
      ) : null
    }
    {...fieldProps}
  />
);

AttributeEditWithInfo.propTypes = {
  attribute: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    label: PropTypes.string,
    data_type: PropTypes.string,
    attribute_origin: PropTypes.string,
  }),
  showAttributeInfo: PropTypes.bool,
  attributeSourceMapping: PropTypes.objectOf(PropTypes.shape({})),
  isSourceMappingLoading: PropTypes.bool,
  isNewVariant: PropTypes.bool,
  fieldProps: PropTypes.shape({}),
};

export default AttributeEditWithInfo;
